import { Description, Download } from '@mui/icons-material';
import { formatDateTime } from '../utils/utils';
import { OrdersTableProps } from './OrdersTable.types';

import './OrdersTable.css';

/**
 * Displays a table of orders with download capability
 * Shows order number, file name, division, legal entity, date, and download button
 * Responsive layout with mobile-optimized display
 */
export function OrdersTable({ ordersData, hasSearched, onDownload, bodyRef }: OrdersTableProps): JSX.Element {
  if (!hasSearched) {
    return (
      <div className="tab-content">
        <div className="no-data">
          <Description sx={{ fontSize: '3rem', marginBottom: '1rem', color: '#ccc' }} />
          <p>Використовуйте фільтри для пошуку розпоряджень</p>
          <p className="no-data-hint">Оберіть дивізіон для початку пошуку</p>
        </div>
      </div>
    );
  }

  if (ordersData.length === 0) {
    return (
      <div className="tab-content">
        <div className="no-data">
          <Description sx={{ fontSize: '3rem', marginBottom: '1rem', color: '#ccc' }} />
          <p>Немає розпоряджень для відображення</p>
          <p className="no-data-hint">Спробуйте змінити критерії пошуку</p>
        </div>
      </div>
    );
  }

  return (
    <div className="orders-results-container">
      <div className="orders-table-wrapper" ref={bodyRef}>
        <table className="orders-results-table">
          <tbody>
            {ordersData.map(order => (
              <tr key={order.id} className="orders-table-row">
                <td className="orders-table-cell orders-col-number">{order.order_number}</td>
                <td className="orders-table-cell orders-col-name">{order.file_name}</td>
                <td className="orders-table-cell orders-col-division">{order.division_name}</td>
                <td className="orders-table-cell orders-col-entity">{order.legal_entity_name}</td>
                <td className="orders-table-cell orders-col-date">{formatDateTime(order.order_datetime)}</td>
                <td className="orders-table-cell orders-col-download">
                  <button className="orders-download-btn" onClick={() => onDownload(order)}>
                    <Download />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
